import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  response: null,
  error: null,
};

const updateSubscriptionSlice = createSlice({
  name: "updateSubscription",
  initialState,
  reducers: {
    updateSubscriptionRequest: (state) => {
      state.loading = true;
      state.error = null;
      state.response = null;
    },
    updateSubscriptionRequestSuccess: (state, action) => {
      state.loading = false;
      state.response = action.payload;
    },
    updateSubscriptionRequestError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  updateSubscriptionRequest,
  updateSubscriptionRequestSuccess,
  updateSubscriptionRequestError,
} = updateSubscriptionSlice.actions;

export default updateSubscriptionSlice.reducer;
